import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import type { StateReferenceDTO, StateReferencePayload } from './types';

export const useUpdateStateReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ id, data: payload }: { id: string; data: Partial<StateReferencePayload> }) => {
			try {
				const { data } = await api.put<StateReferenceDTO>(`/state-reference/update/${id}`, payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar referência');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['state-references'] }),
		onError: error =>
			console.error('Erro ao atualizar referência:', getApiErrorMessage(error, 'Erro ao atualizar referência')),
	});
};
